// client/src/utils/api/tracking.js
import { api, handleRequestError } from "./config";

/**
 * Track a Mailivo click event relayed through Landivo.
 * Returns response.data per project API helper standards.
 */
export const trackMailivoClick = async (payload) => {
  try {
    const response = await api.post("/tracking/click", payload);
    return response.data;
  } catch (error) {
    return handleRequestError(error, "Failed to track Mailivo click");
  }
};
